import React, { useState } from "react";
import { useSelector } from "react-redux";
import { getSuppCartAddCondition } from "../../utils/helperFunctions/supplements";
import { formatUSAmount } from "../../utils/helperFunctions/helperFunctions";
import AddToCartModal from "../EnhanceSailing/AddToCartModal";

const CartItemSupplement = ({
  item,
  onRemove,
  onIncrement,
  onDecrement,
  parent,
}) => {
  const bookingDetails = useSelector((state) => state.bookingValidation.data);
  const [showAddToCartModal, setShowAddToCartModal] = useState(false);
  var { min_qty, max_qty } = getSuppCartAddCondition(
    bookingDetails,
    item.supplement.Selection_method
  );

  if (item.supplement.child?.Selection_method) {
    var { child_min_qty, child_max_qty } = getSuppCartAddCondition(
      bookingDetails,
      item.supplement.child.Selection_method
    );
  }

  // disable increment button if max_qty is reached for adults or children
  // const isAdultMax = item.adults === max_qty;
  // const isChildMax = item.children === child_max_qty;

  // disable decrement button if min_qty is reached for adults or children
  // const isAdultMin = item.adults === min_qty;
  // const isChildMin = item.children === child_min_qty;

  return (
    <div className="flex sm:flex-col lg:flex-row items-center justify-between w-full p-4 border-b border-[#6699C2]">
      <div className="flex w-full gap-2">
        <img
          src={item.supplement.product_image}
          alt={item.supplement.title}
          className="w-24 h-24 object-cover"
        />
        <div className="flex-1 w-full ml-4">
          <div className="w-full gap-2 flex-col-reverse md:flex-row flex justify-between">
            <div>
              {" "}
              <h3 className="text-xl font-semibold text-blue-900">
                {item.supplement.title}
              </h3>
              <div className="flex gap-5 pt-2">
                {" "}
                <p className="text-gray-600">
                  Adult,{" "}
                  <strong>
                    {" "}
                    {item.adults.reduce(
                      (acc, item) => acc + item.quantity,
                      0
                    )}{" "}
                    X
                  </strong>{" "}
                  ${item.supplement.farecode_price.toFixed(2)}
                </p>
                {item.supplement?.child?.farecode_price && (
                  <p className="text-gray-600">
                    Child,
                    <strong>
                      {" "}
                      {item.children.reduce(
                        (acc, item) => acc + item.quantity,
                        0
                      )}{" "}
                      X
                    </strong>{" "}
                    ${item.supplement?.child?.farecode_price.toFixed(2)}
                  </p>
                )}
              </div>
              {parent !== "cartPreview" && (
                <div className="flex items-center gap-12">
                  <div className="flex text-mv-darkblue font-bold text-lg items-center"></div>
                </div>
              )}
            </div>
            <div className="flex md:flex-col gap-4 justify-between md:justify-normal items-end space-x-4">
              <p className="text-xl font-semibold text-blue-900">
                ${formatUSAmount(item.subtotal)}
              </p>
              {parent !== "cartPreview" && (
                <button
                  onClick={() => onRemove(item.supplement.title, "supplement")}
                  className="text-red-500 hover:text-red-700"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5-4h4a2 2 0 012 2v2H8V5a2 2 0 012-2zm-7 6h18"
                    />
                  </svg>
                </button>
              )}
            </div>
          </div>
          <div
            onClick={() => setShowAddToCartModal(true)}
            className=" underline cursor-pointer"
          >
            Edit
          </div>
        </div>
      </div>
      {showAddToCartModal && (
        <div className="fixed bg-mv-backdrop z-10 bg-opacity-80 left-0 right-0 top-0 bottom-0 m-auto">
          <AddToCartModal
            bookingDetails={bookingDetails}
            min_qty={min_qty}
            max_qty={max_qty}
            child_min_qty={child_min_qty}
            child_max_qty={child_max_qty}
            supplement={item.supplement}
            _adults={item.adults}
            _children={item.children}
            setShowAddToCartModal={setShowAddToCartModal}
          />
        </div>
      )}
    </div>
  );
};

export default CartItemSupplement;
